/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import QualificationTypeForm from './QualificationTypeForm';
import { getQualificationTypeListPagination, manageQualificationType, resetQualificationType } from '../actions/masterManagementAction';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import TablePagination from "../../../common/components/TablePagination.jsx"
import ConfirmationDialog from '../../../common/components/ConfirmationDialog';


const QualificationTypeList = () => {
  let rowPerPage = 10;
  let [addQualification, setAddQualification] = useState('');
  let [qualificationTypeToSearch, setQualificationTypeToSearch] = useState(false);
  let [searchMode, setSearchMode] = useState(false);
  let [showModal, setShowModal] = useState(false);
  let [deleteQualificationType, setDeleteQualificationType] = useState(0);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetQualificationType());
    dispatch(getQualificationTypeListPagination(0, rowPerPage, qualificationTypeToSearch));
    // eslint-disable-next-line
  }, [])

  const searchQualType = (qualificationNameToSearch) => {
    setSearchMode(Number(new Date()));
    dispatch(getQualificationTypeListPagination(0, rowPerPage, qualificationNameToSearch));
  }

  const manageQualType = (qualificationTypeId) => {
    setShowModal(true);
    setDeleteQualificationType(qualificationTypeId);
  }

  const activeQualType = (qualificationTypeId, isActive) => {
    let qualificationTypes = {
      qualificationType: { "qualificationtypecode": qualificationTypeId, "isActive": !isActive }
    };
    dispatch(manageQualificationType(qualificationTypes, rowPerPage, listCurrentPage));
  }

  const deleteQualType = (deleteQualificationType) => {
    setShowModal(false);
    let qualificationTypes = {
      qualificationType: { "qualificationtypecode": deleteQualificationType, "isDeleted": true }
    };
    dispatch(manageQualificationType(qualificationTypes, rowPerPage, 0));
  }

  const { qualificationListDetails, qualificationTypePageNoCounter } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  let tableCounter = qualificationTypePageNoCounter + 1;

  return addQualification ? (
    <div>
      <QualificationTypeForm addQualification={addQualification} rowPerPage={rowPerPage} />
    </div>
  ) : (
    <div className="border border-light text-center w-100 p-4">
      <div className='form-group'>
        <div className='row'>
          <div className='col-md-3'>
            <input
              type="text"
              className="form-control"
              name="qualificationTypeNameToSearch"
              value={qualificationTypeToSearch == false ? "" : qualificationTypeToSearch}
              placeholder={masterLabels.qualificationTypeList.BUTTON_SEARCH_PlaceHolder}
              onChange={event => { setQualificationTypeToSearch(event.target.value); setSearchMode(false); }}
              maxLength="50"
            />
          </div>
          <div className='col-md-1'>
            <button className='form-control  btn btn-primary custom_button  button_search  ' onClick={() => { searchQualType(qualificationTypeToSearch); }}><i className="fa fa-search" type="button" ></i></button>
          </div>
          <div className='col-md-5'></div>
          <div className='col-md-4 text-right col-lg-2'>
            <button type="button" className=" btn btn-primary custom_button  btn-sm p-1  " onClick={() => { setAddQualification(true) }}>
              {masterLabels.qualificationTypeList.Add_Qualification_Type_Btn}
            </button>
          </div>
        </div>
      </div>
      <div className='form-group'>
        {qualificationListDetails && qualificationListDetails.totalNumberOfRecords > 0 ?
          <div>
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th scope="col" className='w-10 text-center'>{masterLabels.qualificationTypeList.Tbl_No_Col}</th>
                  <th scope="col" className='w-25 text-left'>{masterLabels.qualificationTypeList.Tbl_TypeCode_Col}</th>
                  <th scope="col" className='w-55 text-left'>{masterLabels.qualificationTypeList.Tbl_TypeName_Col}</th>
                  <th scope="col" className='w-10 text-center'>{masterLabels.qualificationTypeList.Tbl_Action_Col}</th>
                </tr>
              </thead>
              <tbody className='small'>
                {qualificationListDetails && qualificationListDetails.qualificationTypesList && qualificationListDetails.qualificationTypesList.map((element, index) => {
                  if (element) {
                    return (
                      <tr key={index}>
                        <td className="w-10 word-break text-center">{tableCounter++}</td>
                        <td className="text-left ">{element.qualificationtypecode}</td>
                        <td className="text-left">{element.qualificationtypename}</td>
                        <td className="w-10 word-break text-center">
                          <i role="button" data-toggle="tooltip" title={commonLabels.BUTTONS.EDIT} className='text-primary  fa fa-edit' onClick={(e) => { setAddQualification(element.qualificationtypecode) }}></i>
                          &nbsp;&nbsp;
                          <i role="button" data-toggle="tooltip" title={element.isActive ? commonLabels.BUTTONS.INACTIVE : commonLabels.BUTTONS.ACTIVE}
                            className={element.isActive === true ? "text-success fa fa-toggle-on" : "text-danger fa fa-toggle-off"} onClick={(e) => { activeQualType(element.qualificationtypecode, element.isActive); }}></i>
                          &nbsp;&nbsp;
                          <i role="button" data-toggle="tooltip" title={commonLabels.BUTTONS.DELETE} className='text-danger fa fa-trash' onClick={(e) => { manageQualType(element.qualificationtypecode); }}></i>
                        </td>
                      </tr>
                    )
                  }
                })
                }
              </tbody>
            </table>
            <TablePagination
              paginationFor="qualification_type_list"
              rowPerPage={rowPerPage}
              setListCurrentPage={setListCurrentPage}
              textToSearch={qualificationTypeToSearch}
              totalCount={qualificationListDetails.totalNumberOfRecords}
              searchMode={searchMode}
            />
          </div>
          : <font className="text-danger">{commonLabels.NO_DATA_FOUND}</font>}
      </div>

      {
        <ConfirmationDialog
          showModal={showModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowModal}
          deleteRecord={deleteQualType}
          deletedId={deleteQualificationType}
          IsConfirmation={"true"}
        />
      }
    </div>
  );
}

export default QualificationTypeList;